import { ProcessType } from "@scts/models";
  
export const AppDataLocalTax = {
  header: {
    headerText: 'Local Taxation Chamber',
    headerTextMobile: 'Local Taxation',
    menuItems: [
      { displayText: 'Home', routeUri: '/' },
      { displayText: 'About', routeUri: '/about' },
      { displayText: 'FAQs', routeUri: '/faqs' },
      { displayText: 'Legislation', routeUri: '/legislation' },
      { displayText: 'Make an Appeal', routeUri: '/apply' },
      { displayText: 'Active Appeals', routeUri: '/appeals' },
      { displayText: 'Decisions', routeUri: '/decisions' },
      { displayText: 'Hearings', routeUri: '/hearings' },
      { displayText: 'Contact', routeUri: '/contact-us' },
    ],
  },
  footer: {
    backgroundColour: '#105b7d',
    colour: '#fff',
    padding: '0.5rem',
    paddingBottom: '0.25rem',
    copyrightMessage: 'Local Taxation Chamber 2026',
  },
  loader: {
    loadingText: '',
    blinkText: false,
    padding: '0.5rem',
  },
  notFound: {
    links: [
      {
        linkText: 'Home page',
        linkRoute: '/',
        icon: 'bi-house-fill',
      },
      {
        linkText: 'Contact Us',
        linkRoute: '/contact-us',
        icon: 'bi-pencil-square',
      },
    ],
    padding: '1rem',
    margin: '1rem',
  },
  existingAppealTypes: {
    items: [
      {
        title: 'Non-Domestic Rates Appeals',
        body: `The Assessor must notify the Local Taxation Chamber of the Appeal or complaint by 30th April 2023. Once the Local Taxation Chamber receive a note of the appeal or complaint from the Assessor they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`,
      },
      {
        title: 'Appeals against Council Tax Banding',
        body: `The Assessor must notify the Local Taxation Chamber of the Appeal by 30th April 2023. Once the Local Taxation Chamber receive a note of the appeal from the Assessor they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`,
      },
      {
        title: 'Council Tax Liability Appeals',
        body: `The Local Authority must notify the Local Taxation Chamber of the Appeal by 12th May 2023. Once the Local Taxation Chamber receive a note of the Appeal from the Local Authority they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`,
      },
      {
        title: 'Water Charges Appeals',
        body: `The Local Authority must notify the Local Taxation Chamber of the Appeal. Once the Local Taxation Chamber receive a note of the Appeal from the Local Authority they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`,
      },
      {
        title: 'Council Tax Reduction Appeals',
        body: `The Appeals already lodged with the Council Tax Reduction Review Panel will automatically transfer to the Local Taxation Chamber. Once the Local Taxation Chamber receive a note of the appeal from the Council Tax Reduction Review Panel they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number. `,
      },
      {
        title:
          'Appeal against civil penalties imposed as a result of failure to comply with an Assessor Information Notice.',
        body: `The Assessor must notify the Local Taxation Chamber of the Appeal. Once the Local Taxation Chamber receive a note of the appeal from the Assessor they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`,
      },
      {
        title:
          'Appeal against civil penalties imposed as a result of failure to comply with a Local Authority Information Notice.',
        body: `The Local Authority must notify the Local Taxation Chamber of the Appeal. Once the Local Taxation Chamber receive a note of the appeal from the Local Authority they will send the parties an acknowledgement which will detail the Local Taxation Chamber application reference number.`,
      },
    ],
    index: 1,
  },
  contact: {
    address: {
      addressType: '',
      building: 'First Floor, Bothwell House',
      addressLine1: 'Hamilton Business Park',
      addressLine2: 'Caird Park',
      addressLine3: '',
      townCity: 'Hamilton',
      country: '',
      postalCode: 'ML3 0QA',
    },
    orginisationName: 'Local Taxation Chamber',
    email: 'LTCAdmin@scotcourtstribunals.gov.uk',
    phone: '01698 390012',
    phoneText: `Mon - Thur: 9:00 am - 5:00 pm
    Fri:        9:00 am to 4:30 pm
    Sat & Sun:  Closed`,
    publicHolidayText:
      'The office is closed on public and privilege holidays, and office closure dates are posted. ',
    publicHolidayLink:
      'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/public-priviledge-holidays-2026.pdf',
    complaints: [
      {
        name: 'Complaints against Tribunal Members and Judges ',
        url: 'https://www.judiciary.scot/home/publications/judicial-complaints',
      },
      {
        name: 'Complaints against Scottish Courts and Tribunal Service ',
        url: 'http://www.scotcourts.gov.uk/complaints/complaints-and-feedback',
      },
      {
        name: 'Complaints against Advocates and Solicitors ',
        url: 'http://www.scottishlegalcomplaints.org.uk/',
      },
    ],
  },
  usefulLinksFooter1: {
    title: 'Useful Links',
    links: [
      {
        name: 'Tribunals User Charter',
        href: 'https://www.scotcourts.gov.uk/media/xcmllz1h/214-tribunals-customer-charter-leaflet-v7-july-2024.pdf',
        external: true,
      },
      {
        name: 'COSLA',
        href: 'https://www.cosla.gov.uk/',
        external: true,
      },
      {
        name: 'Shelter Scotland',
        href: 'https://scotland.shelter.org.uk/',
        external: true,
      },
    ],
  },
  usefulLinksFooter2: {
    title: 'Tribunals User Charter',
    links: [
      {
        name: 'Scottish Assessors Association',
        href: 'https://www.saa.gov.uk/',
        external: true,
      },
      {
        name: 'Citizens Advice Scotland',
        href: 'https://www.cas.org.uk/',
        external: true,
      },
    ],
  },
  taxLinks1: {
    title: 'Local Taxation Chamber Links',
    links: [
      {
        href: '/reviews',
        name: 'Appeal or Review Decision',
        external: false,
      },
      {
        href: '/foi',
        name: 'Freedom of Information',
        external: false,
      },
      {
        href: '/hearings',
        name: 'Forthcoming Hearings',
        external: false,
      },
    ],
  },
  taxLinks2: {
    title: ' - ',
    links: [
      {
        href: 'https://www.scotcourts.gov.uk/about-the-scottish-court-service/contact-us/data-protection',
        name: 'Privacy',
        external: true,
      },
      {
        href: '/accessibility',
        name: 'Accessibility',
        external: false,
      },
      {
        href: '/terms',
        name: 'Terms & Conditions',
        external: false,
      },
    ],
  },
  faqs: [
    {
      title: 'What is the Local Taxation Chamber?',
      body: `The Tribunals (Scotland) Act 2014 created a new statutory framework for tribunals in Scotland. The Act created two new tribunals, the First-tier Tribunal for Scotland and the Upper Tribunal for Scotland, known collectively as the Scottish Tribunals. The First-tier Tribunal consists of a number of Chambers, each with its own jurisdiction and headed by a Chamber President. 

        The First-tier Tribunal for Scotland deals with first instance decisions. These are cases heard at a tribunal for the first time.

        The functions of the Valuation Appeals Committees and the Council Tax Reduction Review Panel transferred into the Local Taxation Chamber on 1st April 2023. On 1st April 2026, the remit of the Chamber expanded with the introduction of visitor levy appeals.
      `,
      section: '',
      links: [
        {
          url: 'https://www.judiciary.scot/home/judiciary/judicial-office-holders/tribunals',
          text: 'Learn more about Tribunals',
        },
        {
          url: 'https://www.saa.gov.uk/non-domestic-valuation/the-valuation-roll/valuation-appeal-committee/',
          text: 'Valuation Appeals Committee',
        },
        {
          url: 'https://www.counciltaxreductionreview.scot/',
          text: 'Council Tax Reduction Review Panel',
        },
      ],
    },
    {
      title: 'Is this the same as the Tax Chamber?',
      body: `
      No.  The First-tier Tribunal for Scotland Tax Chamber decides appeals relating to Lands and Buildings Transaction Tax and Scottish Landfill Tax.      `,
      section: '',
    },
    {
      title: 'How will the Local Taxation Chamber determine appeals?',
      body: `Appeals will be determined by the Tribunal following a hearing. However, if the parties and the Tribunal agree the appeal may be determined on the basis of written representations.`,
      section: '',
    },
    {
      title: 'What if I don’t have access to a computer or internet?',
      body: `The tribunal’s normal way of working is to hold virtual hearings. The tribunal will only consider holding a face-to-face hearing in exceptional circumstances where it is deemed necessary for the fair administration of justice. Any application for a face-to-face hearing must be supported by compelling reasons to justify a departure from the tribunal’s normal way of working.`,
      section: '',
    },
    {
      title: 'How will I find out the outcome of my appeal?',
      body: `When an appeal is decided at a hearing you may be told the decision orally at the hearing or advised in writing later.

      The Tribunal's written decision will be provided as soon as possible after the Tribunal have made their decision
      `,
      section: '',
    },
    {
      title: 'Will the decisions be made public?',
      body: `Decisions (other than Council Tax Reduction decisions) will be published on this website.`,
      section: '',
      links: [
        {
          url: '/decisions',
          text: 'Go to decisions page',
        },
      ],
    },
    {
      title: 'Is there a fee for lodging an appeal?',
      body: `There is no fee for lodging an appeal with the Local Taxation Chamber. A fee will have to be paid for Non-domestic rates referrals to the Upper Tribunal. `,
      section: '',
    },
    {
      title: 'How do I make a complaint?',
      body: `Information on how to make a complaint is available on the Contact page.`,
      section: '',
      links: [
        {
          url: '/contact-us',
          text: 'Go to contact page',
        },
      ],
    },
    {
      title: 'Who are the members of the Local Taxation Chamber?',
      body: `Information on Members is available via the About page on this website.`,
      section: '',
      links: [
        {
          url: '/about',
          text: 'Go to about page',
        },
      ],
    },
    {
      title: 'How will my hearing take place?',
      body: `The majority of hearings will take place remotely via Webex. You will receive a link to log on to the hearing at the time it is scheduled to take place. Make sure you can connect to the hearing in good time, we suggest you join the hearing at least 5 minutes early. Once joined, you will be held in a waiting room (lobby) until the hearing can start. The clerk will admit you to the hearing at your given time. We recommend you wear a headset with a microphone, if possible as this helps with audio.`,
      section: '',
    },
    {
      title: 'What are written representations?',
      body: `Written representations are written statements and evidence submitted by parties detailing their case, arguments, and supporting documents which supplement oral representations made by the parties at the hearing.

            If an appeal is determined on the basis of the parties’ written representations, the written representations by an Appellant will fully set out the grounds and basis of the appeal and the written representations by the Respondent will set out the Respondent’s response to the grounds of appeal.`,
      section: '',
    },
    {
      title: 'Which form am I supposed to fill out?',
      body: `Unfortunately, the Tribunal are unable to provide you with any legal advice or guidance as we are an independent and impartial body. Should you require any legal advice in relation to your appeal this can be sought from:

            •	A solicitor. A list of solicitors is available on the Law Society of Scotland website. 
            •	Citizens Advice Scotland – www.cas.org.uk - 0808 800 9060  
            •	Strathclyde Law Clinic – www.lawclinic.org.uk - 0141 548 5995
            •	Glasgow Caledonian Law Clinic – lawclinic@gcu.ac.uk - 0141 331 8098  
            •	A Rating Agent (in relation to Non-Domestic Rates Appeals). A list is available on the Royal Institution of Chartered Surveyors (RICS) website.`,
      section: '',
    },
    {
      title: 'How long will I have to wait for a hearing?',
      body: `As every appeal is different, they are treated individually and timescales may vary, therefore there is no standard timescale for scheduling a hearing. As soon as your appeal is scheduled for hearing you will be notified. The list of forthcoming hearings is also listed on the Chamber website.`,
      section: '',
    },
    {
      title: 'What if I am unhappy with a decision issued by the Tribunal?',
      body: `When a decision is issued, you will also receive guidance on how to ask the Tribunal to review the decision and how to appeal the decision. The guidance outlines how to do this and the timescales within which this must be done. A copy of this, and other guidance can be found on the ‘Make an Appeal’ page.`,
      section: '',
    },
  ],
  appealTypesCt: {
    items: [
      {
        id: 'ct-banding',
        title: 'Appeals against Council Tax Banding and the inclusion or exclusion of a Property in the Valuation List',
        body: `The Scottish Assessors are responsible for maintaining the council tax valuation list, which contains
        information relating to each domestic property in a local authority area. 
        
        The Chamber hears appeals regarding entries made by Assessors to the valuation list of domestic properties.`,
        links: [
          {
            text: 'Notes on completing Form C-4b',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4b (Proposal Not well founded) NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form C-4b',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4b (Proposal Not well founded).pdf',
          },
        ],
        processFlow: [],
      },
      {
        id: 'ct-invalid',
        title: 'Invalid Council Tax Banding Appeals',
        body: `Council tax Banding Proposals must generally be sent to the Assessor within 6 months of the date that you first become liable to pay council tax for the Property. Please see above the link to the Scottish Assessors website for the detailed time limits. If you sent your Proposal to the Assessor late the Assessor will find that the Proposal is invalid. The Assessor will send you a Notice advising that the Proposal was invalid. The Assessor may also determine that Proposals are invalid due to lack of title or lack of information. `,
        links: [
          {
            text: 'Notes on completing Form C-4a',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4a (Proposal Invalid) NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form C-4a',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4a (Proposal Invalid).pdf',
          },
        ],
        processFlow: [],
      },
      {
        id: 'ct-liability',
        title:
          'Council Tax Liability Appeals (Calculation of Council Tax Liability, Exemptions and Discounts)',
        body: `The Chamber also hears other council tax appeals such as the calculation of council tax liability, exemptions and discounts.

        If you have written to the Local Authority saying that you are aggrieved by their decision on council tax liability, exemptions or discounts and you still believe the Local Authority are wrong you can appeal to the Local Taxation Chamber.`,
        links: [
          {
            text: 'Notes on completing Form C1',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C1 (liability)NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form C1',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C1 (liability).pdf',
          },
        ],
        processFlow: [],
      },
      {
        id: 'ct-reduction',
        title: 'Council Tax Reduction Appeals',
        body: `If you have asked the Local Authority to review a decision they have made about your council tax reduction and you still believe the Local Authority are wrong after they have reviewed their decision you can appeal to the Local Taxation Chamber.`,
        links: [
          {
            text: 'Notes on completing Form D',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM D (Reduction Review) NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form D',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM D (Reduction Review).pdf',
          },
        ],
        processFlow: [],
      },
      {
        id: 'ct-completion',
        title: 'Council Tax Completion Notice Appeals',
        body: `Completion Notices for new buildings are issued by the Assessor. The Completion Notice details the date erection of the Property is to be treated as completed. The Chamber hears Completion Notice appeals.`,
        links: [
          {
            text: 'Notes on completing Form C3',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C3 (Completion Notice)NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form C3',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C3 (Completion Notice).pdf',
          },
        ],
        processFlow: [],
      },
      {
        id: 'ct-penalty',
        title: 'Council Tax Penalty Notice Appeals',
        body: `The Chamber also hears Council Tax Penalty Notice appeals.`,
        links: [
          {
            text: 'Notes on completing Form C2',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C2 (Council Tax Penalty)(NOTES).pdf',
          },
          {
            text: 'Notice of Appeal Form C2',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C2 (Council Tax Penalty).pdf',
          },
        ],
        processFlow: [],
      },
    ],
    index: 1,
  },
  appealTypesNdr: {
    items: [
      {
        id: 'ndr-appeal',
        title: 'Non-Domestic Rates Appeals',
        processType: 'Appeal' as ProcessType,
        body: `The Assessors are responsible for maintaining the Valuation Roll which lists each non-domestic property in a local authority area and gives their Net Annual Value and Rateable Value. 
        
        The Non-Domestic Rates (Scotland) Act 2020 introduced a two stage appeal system. If you don’t agree with an entry in the Valuation Roll you must first send the Assessor a Proposal which advises the Assessor of the Valuation Roll entry that you consider to be incorrect. 
        
        Information on how to make a Non-Domestic Rates proposal can be found on the website of the {{LINK}}.

        The Assessor will issue a Proposal Determination Date and issue their decision on or before the Proposal Determination Date.
        
        The Assessor may decide to alter the entry in the Valuation Roll in accordance with the Proposal. Alternatively the Assessor may decide not to alter the entry in the Valuation Roll or may alter the entry other than in accordance with the Proposal. If you do not agree with Assessor’s refusal to amend the entry in the Valuation Roll or if you do not agree with the amended entry you can appeal to the Local Taxation Chamber.  

        In complex or highly technical appeals applications can be made to the Tribunal for an appeal to be referred to the Upper Tribunal. If the Tribunal has decided not to refer an appeal to the Upper Tribunal an appeal against that decision can be lodged direct with the Upper Tribunal.`,
        links: [
          {
            text: 'Notes on completing Form A',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM A (NDR)NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form A',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM A (NDR).pdf',
          },
        ],
        processFlow: [],
      },
      {
        id: 'ndr-complaint',
        title: 'Non-Domestic Rates Complaints',
        processType: 'Complaint' as ProcessType,
        body: `The Assessors are responsible for maintaining the Valuation Roll which lists each non-domestic property in a local authority area and gives their Net Annual Value and Rateable Value. A complaint to the Local Taxation Chamber can be made about an entry in the Valuation Roll if you have interest but are not the proprietor, tenant or occupier of the property concerned.`,
        links: [
          {
            text: 'Notes on completing Form B',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM B (NDR Complaint) NOTES.pdf',
          },
          {
            text: 'Notice of Complaint Form B',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM B (NDR Complaint).pdf',
          },
        ],
        processFlow: [],
      },
      {
        id: 'ndr-penalty',
        title: 'Non-Domestic Rates Penalty Notice Appeals',
        processType: 'Appeal' as ProcessType,
        body: `The Chamber will also hear Non-Domestic Rates Penalty Notice appeals. `,
        links: [
          {
            text: 'Notes on completing Form E',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM E (NDR Penalty) NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form E',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM E (NDR Penalty).pdf',
          },
        ],
        processFlow: [],
      },
    ],
  },
  appealTypesVla: {
    items: [
      {
        id: 'vla',
        title: 'Visitor Levy Appeals',
        body: ``,
        links: [
          {
            text: '',
            url: '', // https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C-4b (Proposal Not well founded) NOTES.pdf
          },
          {
            text: '',
            url: '',
          },
        ],
        processFlow: [],
      }
    ]
  },
  appealTypesVisitorLevy: {
    items: [
      {
        id: 'vl-appeal',
        title: 'Visitor Levy Appeals',
        body: `If you have asked the Local Authority to review a decision they have made about your visitor levy and you still believe the Local Authority are wrong after they have reviewed their decision you can appeal to the Local Taxation Chamber.`,
        links: [
          {
            text: 'Notes on completing Form F',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM F (Visitor Levy) NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form F',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM F (Visitor Levy).pdf',
          },
        ],
        processFlow: [],
      }
    ]
  },
  additionalGuidance: {
    items: [
      {
        id: 'ag',
        title: 'Additional Guidance',
        body: `The Local Taxation Chamber has published the following additional guidance and information to assist parties.`,
        links: [],
        processFlow: [],
      },
    ],
  },
  additionalGuidanceSubsections: {
    items: [
      {
        id: 'ag-appeal-review',
        title: 'Appeal and Review Guidance',
        body: ``,
        links: [
          {
            text: 'Council Tax, Council Tax Reduction and Water Charges Appeals - Appeal and Review Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Council Tax Council Tax Reduction and Water Charges Appeal and Review Guidance.pdf',
          },
          {
            text: 'Non-Domestic Rates Appeals – Referral to the Upper Tribunal for Scotland Decisions – Appeal and Review Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Non-Domestic Rates – Referral to the Upper Tribunal for Scotland Decisions – Appeal and Review Guidance.pdf',
          },
          {
            text: 'Non-Domestic Rates Appeals – Non-valuation Decisions – Appeal Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Non-Domestic Rates – Non-valuation Decisions – Appeal Guidance.pdf',
          },
          {
            text: 'Non-Domestic Rates Appeals – Valuation Decisions – Appeal Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Non-Domestic Rates – Valuation Decisions – Appeal Guidance.pdf',
          },
          {
            text: 'Non-Domestic Rates Appeals – Penalty Notice Appeals – Appeal and Review Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Non-Domestic Rates – Penalty Notice Appeals – Appeal and Review Guidance.pdf',
          }
        ],
        processFlow: [],
      },
      {
        id: 'ag-documentary-evidence',
        title: 'Documentary Evidence Guidance',
        body: ``,
        links: [
          {
            text: 'Documentary Evidence Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Documentary Evidence Guidance.pdf',
          },
        ],
        processFlow: [],
      },
      {
        id: 'ag-hearing',
        title: 'Hearing Guidance',
        body: ``,
        links: [
          {
            text: 'Virtual Hearing Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/LTC Virtual Hearing Guidance.pdf',
          },
          {
            text: 'Hearing Guidance for Observers',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Hearing Guidance for Observers.pdf',
          },
          {
            text: 'Council Tax Appeals – Virtual Hearing Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Local Taxation Chamber Virtual Council Tax Appeals.pdf',
          },
          {
            text: 'Non-Domestic Rates Appeals – Virtual Hearing Guidance',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Local Taxation Chamber NDR Virtual Appeal Guidance .pdf',
          },
        ],
        processFlow: [],
      },
    ]
  },
  observersGovernance: {
    name: 'guidance for hearing observers',
    href: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Guidance for Observers.pdf',
    external: true,
  },
  takingOfOralEvidence: {
    name: 'taking of oral evidence from persons located overseas in tribunal proceedings',
    href: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Taking of oral evidence from persons located overseas.pdf',
  },
  appealTypesWater: {
    items: [
      {
        id: 'ct-water',
        title: 'Water Charges Appeals',
        body: `The Chamber hears appeals against a Local Authority decision that water charges are payable or the calculation of water charges liability.`,
        links: [
          {
            text: 'Notes on completing Form C5', 
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C5(Water Charges)NOTES.pdf',
          },
          {
            text: 'Notice of Appeal Form C5',
            url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/APPEAL FORM C5(Water Charges).pdf',
          },
        ],
        processFlow: [],
      },
    ],
  },
  reviewFaqs: [
    {
      title: 'What if a party wishes to appeal a Non-Domestic Rates Decision ?',
      body: `Non-Domestic Rates decisions made by the Tribunal are appealed to the Lands Valuation Appeal Court by stated case. 
      
      The appeal procedure is regulated by Act of Sederunt (Valuation Appeal Rules Amendment) 1982, as amended.
      
      The Appellant must lodge their grounds of appeal with the Tribunal within 14 days of the date on which the Tribunal decision was issued to them. At the same time a copy must be provided to the opposite party who has 14 days to lodge answers to the grounds of appeal with the Tribunal. 
      
      Within six weeks after the appellant has lodged their grounds of appeal the Tribunal shall issue the draft stated case to the appellant and the respondent. 
      
      Within four weeks of the date the draft stated case has been issued to the parties either party may make revisals and provide them to the Tribunal. 
      
      Objections to the revisals may be lodged with the Tribunal within two weeks.
      
      The Tribunal must lodge the signed stated case with the Lands Valuation Appeal Court within 14 days of the last date on which revisals may be made
      `,
      section: '',
      listItems: [],
    },
    {
      title: 'What if a party wishes to appeal a Council Tax Decision ?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'An application for permission to appeal must be made in writing to the First-tier Tribunal',
          subList: [],
        },
        {
          listItem: 'The application must',
          subList: [
            'Identify the decision to which the application for permission relates',
            'Identify the point or points of law on which the applicant wishes to appeal',
            'State the result the applicant is seeking',
          ],
        },
        {
          listItem:
            'Permission must be sought within 30 days -  ie the application for permission must be received within 30 days of:',
          subList: [
            'The decision being appealed against being sent to the appellant OR',
            'if later, a statement of reasons being sent to the appellant OR',
            'the date of the hearing at which the decision was given orally  - unless written reasons were requested (within 14 days of the hearing), and the Tribunal undertook to provide them, in which case within 30 days of the date they were sent',
          ],
        },
        {
          listItem:
            'The First-tier Tribunal for Scotland has power to extend the time for requesting permission to appeal “on cause shown”',
          subList: [],
        },
      ],
    },
    {
      title: 'What is a “Point of Law”?',
      body: `“The Inner House of the Court of Session in the case of Advocate General for Scotland v Murray Group Holdings Limited (2015) CSIH 77 identified four different categories of case covered by the concept of an appeal upon a point of law: these are 

      (i) an error of general law, the content of its rules; 
      (ii) an error in the application of the law to the facts; 
      (iii) making findings in fact without a basis in the evidence; and 
      (iv) taking a wrong approach to the case by, for example, asking the wrong questions or taking account of manifestly irrelevant considerations, or by arriving at a decision that no reasonable tribunal can properly reach.”
 
      Per DECISION NOTICE OF SHERIFF I FLEMING in the case of ABDUL MAJID and ADELE GAFFNEY AND ANDREW ROBERT BRITTON [2019] UT 59
      `,
      section: '',
      listItems: [],
    },
    {
      title: 'Which decisions may be appealed?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'Any decision that is not an excluded decision in terms of the Tribunals (Scotland) Act 2014 (see Section 46(5)).',
          subList: [],
        },
        {
          listItem:
            'A refusal of permission to appeal is not reviewable OR appealable (Section 55(2) of the Tribunals (Scotland) Act 2014).',
          subList: [],
        },
        {
          listItem:
            'A decision in a review (being the decision to set aside, take no action, or correct a minor or accidental error) is not reviewable OR appealable (Section 52 of the Tribunals (Scotland) Act 2014)',
          subList: [],
        },
      ],
    },
    {
      title: 'What decision can the First-tier Tribunal for Scotland make?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'Permission to appeal may be granted by the Local Taxation Chamber of the First-tier Tribunal for Scotland, or',
          subList: [],
        },
        {
          listItem: 'Permission may be granted in part, or',
          subList: [],
        },
        {
          listItem: 'Permission may be refused',
          subList: [],
        },
      ],
    },
    {
      title:
        'What if Permission to Appeal is granted by the First-tier Tribunal for Scotland?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'The appellant may then submit an appeal to the Upper Tribunal for Scotland',
          subList: [],
        },
      ],
    },
    {
      title:
        'What if Permission to Appeal is refused by the First-tier Tribunal for Scotland?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem: 'The decision is not reviewable or appealable',
          subList: [],
        },
        {
          listItem:
            'If permission is refused, the appellant may then seek permission to appeal from the Upper Tribunal for Scotland',
          subList: [],
        },
      ],
    },
    {
      title:
        'What if Permission to Appeal is granted in part by the First-tier Tribunal for Scotland?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem: 'The decision is not reviewable or appealable',
          subList: [],
        },
        {
          listItem: 'The appellant must decide whether to',
          subList: [
            'apply to the Upper Tribunal for Scotland for permission to appeal the points that were not granted by the First-tier Tribunal for Scotland, or',
            'submit an appeal to the Upper Tribunal for Scotland to determine only the points that were granted by the First-tier Tribunal for Scotland',
          ],
        },
      ],
    },
    {
      title: 'What is the timescale for applying to the Upper Tribunal?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'The application must be made within 30 days of the date on which the grant or refusal of permission was sent to the appellant',
          subList: [],
        },
        {
          listItem:
            'The 30 day period can be extended by the Upper Tribunal “on cause shown”.',
          subList: [],
        },
      ],
    },
    {
      title: 'What is “Review”?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'This is where both the First-tier Tribunal for Scotland (Local Taxation Chamber) and the Upper Tribunal for Scotland have the power to review their own decisions.',
          subList: [],
        },
      ],
    },
    {
      title: 'How is a Review triggered?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'The relevant tribunal may decide at its own instance decide to review a decision or a party to the case can ask it to do so.',
          subList: [],
        },
      ],
    },
    {
      title: 'On what basis can the tribunal review its decision?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'If, in the interests of justice, it considers it is necessary to do so.',
          subList: [],
        },
      ],
    },
    {
      title: 'Which decisions may be reviewed?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'Any decision that is not an excluded decision in terms of the Tribunals (Scotland) Act 2014 (see Section 43(3))',
          subList: [],
        },
        {
          listItem:
            'A decision on a Non-Domestic Rates Appeal cannot be reviewed ( Rule 19(2) The First tier Tribunal for Scotland Local Taxation Chamber (Rules of Procedure) Regulations 2022).',
          subList: [],
        },

        {
          listItem:
            'A refusal of permission to appeal is not reviewable OR appealable (Section 55(2) of the Tribunals (Scotland) Act 2014).',
          subList: [],
        },
        {
          listItem:
            'A decision in a review (being the decision to set aside, take no action, or correct a minor or accidental error) is not reviewable OR appealable (Section 52 of the Tribunals (Scotland) Act 2014)',
          subList: [],
        },
      ],
    },
    {
      title: 'What time limits apply to reviews?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'An application for review by a party must be sought within 14 days -  i.e. the application for review must be received by the First-tier Tribunal for Scotland within 14 days of:',
          subList: [
            'the decision being made  OR',
            'if later, the written statement of reasons being sent to the parties.',
          ],
        },
      ],
    },
    {
      title: 'What is the procedure for a review?',
      body: ``,
      section: '',
      listItems: [
        {
          listItem:
            'The application for review must be in writing and must state why a review is necessary. The party seeking a review must send a copy of the application for review to all other parties.',
          subList: [],
        },
        {
          listItem:
            'If the tribunal revise the decision and statement of reasons following review, either at the request of a party or on its own initiative, the revised decision is treated as a fresh decision and there is a period of 14 days from the issue of the revised decision for seeking a review, and a period of 30 days from the issue of the revised decision for seeking permission to appeal.',
          subList: [],
        },
        {
          listItem:
            'If the decision and statement of reasons are not revised, the 30 days for seeking permission to appeal runs from the date of issue of the original decision but excludes any review period. The review period starts on the day the review request is received by the Tribunal and ends on the day the Tribunal sent the review decision to the parties. The decision can only be reviewed once. ',
          subList: [],
        },
      ],
    },
  ],
  accessibility: {
    contactEmail: 'LTCAdmin@scotcourtstribunals.gov.uk',
    complianceIssues: [
      `Our downloadable application forms are currently not completely accessibile when using screen reader software. If you have issues when trying to access these forms, please contact the Local Taxation Chamber using the further contact details on our "Contact" page.`,
      `On some mobiles our downloadable forms may require specific software to be installed, from the app store, to enable edit capabilities. Search for 'Edit PDF' `
    ],
    additionalItems: [
      {
        title: 'Hearing Accessibility Form',
        body: 'If you have any specific requirements for attendance at, and participation in, a Hearing of the Local Taxation Chamber then please complete the form below.',
        url: 'https://ltcdvstrauks003.blob.core.windows.net/appeal-forms/Accessibility Form.pdf',
        urlName: 'Download accessibility hearing form',
      },
    ],
  },
  terms: {
    disclaimer: `The inclusion of a link on this website does not constitute recommendation, endorsement, approval or support of said website or any part thereof by the Local Taxation Chamber (LTC), nor does it imply any responsibility on the part of the LTC for any information the website may contain.
    
    The LTC makes no warranty, either express or implied, as to the accuracy, availability or content of any information, data, text or graphics not under the  https://www.localtaxationchamber.scot domain. It has not tested any of the software located on the linked sites and does not make any representation as to the quality, safety, reliability or suitability of said software.
    
    The LTC reserves the right to add or remove links at its discretion and without prior warning to the operators of the site(s) concerned.
    
    The LTC is under no obligation to comply with requests to add a link to a website or requests by third parties to remove a link to a website.`,
  },
  legislation: {
    items: [
      {
        title: 'Non-domestic rates legislation (including Valuation Regulations)',
        links: [
          {
            text: 'Non-domestic rates legislation',
            url: 'https://www.gov.scot/publications/non-domestic-rates-legislation/',
          },
        ],
      },
      {
        title: 'Council Tax Reduction Regulations',
        links: [
          {
            text: 'Council Tax Reduction (Scotland) Regulations 2021',
            url: 'https://www.legislation.gov.uk/ssi/2021/249/contents',
          },
          {
            text: 'Council Tax Reduction (State Pension Credit) (Scotland) Regulations 2012',
            url: 'https://www.legislation.gov.uk/ssi/2012/319/contents',
          },
        ],
      },
      {
        title: 'Council Tax Legislation',
        links: [
          {
            text: 'Council Tax legislation',
            url: 'https://www.gov.scot/publications/council-tax-legislation/',
          },
          {
            text: 'The Council Tax (Discounts) (Scotland) Amendment Order 2023',
            url: 'https://www.legislation.gov.uk/ssi/2023/25/contents/made',
          },
        ],
      },
      {
        title: 'Visitor Levy Legislation',
        links: [
          {
            text: 'Visitor Levy (Scotland) Act 2024',
            url: 'https://www.legislation.gov.uk/asp/2024/8/contents',
          },
          {
            text: 'The Visitor Levy (Scotland) Act 2024 (Commencement) Regulations 2024',
            url: 'https://www.legislation.gov.uk/ssi/2024/231/made',
          },
          {
            text: 'The Visitor Levy (Scotland) Act 2024 Amendment Regulations 2026',
            url: 'https://www.legislation.gov.uk/ssi/2026/116/contents/made',
          },
          {
            text: 'The Visitor Levy (Reviews and Appeals) (Scotland) Regulations 2026',
            url: 'https://www.legislation.gov.uk/ssi/2026/109/contents/made',
          },
          {
            text: 'The Visitor Levy (Local Authority Assessment) (Scotland) Regulations 2026',
            url: 'https://www.legislation.gov.uk/ssi/2026/108/contents/made',
          },
          {
            text: 'The Visitor Levy (Interest on Unpaid Levy and Penalties) (Scotland) Regulations 2026',
            url: 'https://www.legislation.gov.uk/ssi/2026/9/contents/made',
          },
        ],
      },
      {
        title: 'Transfer and Procedure Regulations',
        links: [
          {
            text: 'The First-tier Tribunal for Scotland Local Taxation Chamber (Rules of Procedure) Regulations 2022',
            url: 'https://www.legislation.gov.uk/ssi/2022/364/contents',
          },
          {
            text: 'The First-tier Tribunal for Scotland Local Taxation Chamber and Upper Tribunal for Scotland (Rules of Procedure)(Miscellaneous Amendment Regulations 2023.',
            url: 'https://www.legislation.gov.uk/ssi/2023/40/contents/made',
          },
          {
            text: 'The First-tier Tribunal for Scotland (Transfer of Functions of the Council Tax Reduction Review Panel) Regulations 2023',
            url: 'https://www.legislation.gov.uk/ssi/2023/46/contents/made',
          },
          {
            text: 'The First-tier Tribunal for Scotland (Transfer of Functions of Valuation Appeals Committees) Regulations 2023',
            url: 'https://www.legislation.gov.uk/ssi/2023/45/contents/made',
          },
          {
            text: 'The First-tier Tribunal for Scotland Local Taxation Chamber and Upper Tribunal for Scotland (Composition) Regulations 2023',
            url: 'https://www.legislation.gov.uk/ssi/2023/47/contents/made',
          },
          {
            text: 'Act of Sederunt (Valuation Appeal Rules Amendment) 2023',
            url: 'https://www.legislation.gov.uk/ssi/2023/76/made',
          },
          {
            text: 'The First-tier Tribunal for Scotland Local Taxation Chamber and Upper Tribunal for Scotland  (Rules of Procedure and Composition) (Miscellaneous Amendment) Regulations 2026',
            url: 'https://www.legislation.gov.uk/ssi/2026/105/made',
          },
          {
            text: 'The First-tier Tribunal for Scotland (Allocation of Functions to the Local Taxation Chamber) Regulations 2026',
            url: 'https://www.legislation.gov.uk/ssi/2026/149/contents/made',
          },
          {
            text: 'The First-tier Tribunal for Scotland Local Taxation Chamber and Upper Tribunal for Scotland (Composition and Rules of Procedure) (Miscellaneous Amendment) Regulations 2026',
            url: 'https://www.legislation.gov.uk/ssi/2026/161/contents/made',
          },
        ],
      },
    ],
  },
  foi: {
    linkTitle: 'Scottish Courts and Tribunals website',
    linkUrl:
      'https://www.scotcourts.gov.uk/about-the-scottish-court-service/contact-us/freedom-of-information',
  },
  hearings: [
    {
      date: '23/06/2023',
      time: '10:00',
      venue:
        'Glasgow Tribunals Centre, Room 112, 20 York Street, Glasgow, G2 8GT',
      reference: 'FTS/HPC/CV/23/0845',
      type: 'Oral Hearing',
      appellant: 'Forename1 Surname1',
      respondent: 'ResponedentForename1 RespondentSurname1',
    },
    {
      date: '24/06/2023',
      time: '11:30',
      venue:
        'Edinburgh Tribunals Centre, Room 215, 35 Princes Street, Edinburgh, EH2 4PG',
      reference: 'FTS/HPC/CV/23/0846',
      type: 'Oral Hearing',
      appellant: 'Forename2 Surname2',
      respondent: 'ResponedentForename2 RespondentSurname2',
    },
    {
      date: '25/06/2023',
      time: '14:15',
      venue:
        'Aberdeen Tribunals Centre, Room 101, 10 Union Street, Aberdeen, AB10 1QT',
      reference: 'FTS/HPC/CV/23/0847',
      type: 'Oral Hearing',
      appellant: 'Forename3 Surname3',
      respondent: 'ResponedentForename3 RespondentSurname3',
    },
    {
      date: '26/06/2023',
      time: '16:45',
      venue:
        'Dundee Tribunals Centre, Room 307, 5 High Street, Dundee, DD1 1SX',
      reference: 'FTS/HPC/CV/23/0848',
      type: 'Oral Hearing',
      appellant: 'Forename4 Surname4',
      respondent: 'ResponedentForename4 RespondentSurname4',
    },
    {
      date: '27/06/2023',
      time: '09:30',
      venue:
        'Inverness Tribunals Centre, Room 410, 15 Bridge Street, Inverness, IV1 1HG',
      reference: 'FTS/HPC/CV/23/0849',
      type: 'Oral Hearing',
      appellant: 'Forename5 Surname5',
      respondent: 'ResponedentForename5 RespondentSurname5',
    },
    {
      date: '28/06/2023',
      time: '13:00',
      venue: 'Perth Tribunals Centre, Room 506, 25 King Street, Perth, PH2 2DR',
      reference: 'FTS/HPC/CV/23/0850',
      type: 'Oral Hearing',
      appellant: 'Forename6 Surname6',
      respondent: 'ResponedentForename6 RespondentSurname6',
    },
    {
      date: '29/06/2023',
      time: '15:45',
      venue:
        'Stirling Tribunals Centre, Room 312, 30 Castle Street, Stirling, FK8 1EH',
      reference: 'FTS/HPC/CV/23/0851',
      type: 'Oral Hearing',
      appellant: 'Forename7 Surname7',
      respondent: 'ResponedentForename7 RespondentSurname7',
    },
    {
      date: '30/06/2023',
      time: '12:15',
      venue:
        'Glasgow Tribunals Centre, Room 203, 20 York Street, Glasgow, G2 8GT',
      reference: 'FTS/HPC/CV/23/0852',
      type: 'Oral Hearing',
      appellant: 'Forename8 Surname8',
      respondent: 'ResponedentForename8 RespondentSurname8',
    },
    {
      date: '01/07/2023',
      time: '14:30',
      venue:
        'Edinburgh Tribunals Centre, Room 112, 35 Princes Street, Edinburgh, EH2 4PG',
      reference: 'FTS/HPC/CV/23/0853',
      type: 'Oral Hearing',
      appellant: 'Forename9 Surname9',
      respondent: 'ResponedentForename9 RespondentSurname9',
    },
    {
      date: '02/07/2023',
      time: '10:45',
      venue:
        'Aberdeen Tribunals Centre, Room 315, 10 Union Street, Aberdeen, AB10 1QT',
      reference: 'FTS/HPC/CV/23/0854',
      type: 'Oral Hearing',
      appellant: 'Forename10 Surname10',
      respondent: 'ResponedentForename10 RespondentSurname10',
    },
  ],
};

